import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export function EnableIpRestrictionModal({
  isOpen,
  organizationName,
  allowedIpCount,
  isSubmitting,
  onConfirm,
  onClose,
}: {
  isOpen: boolean
  organizationName: string
  allowedIpCount: number
  isSubmitting: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>IPアドレス制限を有効にしますか？</DialogTitle>
          <DialogDescription>
            「{organizationName}」の管理者は、許可した{allowedIpCount}
            件のIPアドレス以外からログインも操作もできなくなります。ログイン中の管理者も、次の操作から制限されます。
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={onConfirm} disabled={isSubmitting}>
            有効にする
          </Button>
          <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
            キャンセル
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
